import React from 'react';
import Link from '../Link';
import EventDate from './EventDate/EventDate';

import './index.scss';

const CardEvent = ({ day, hour, title, url, color, tag, fullDate, location }) => {
  return (
    <Link to={url} className="card-event">
      <div className="date">
        <EventDate day={day} hour={hour} color={color} fullDate={fullDate} />
      </div>

      <div className="content">
        <div className="information">
          <h3>{title}</h3>
          <div className="meta">
            <span>
              {tag} {location && ` / ${location}`}
            </span>
          </div>
        </div>

        <div className="card-action">
          <span>Learn more</span>
        </div>
      </div>
    </Link>
  );
};

export default CardEvent;
